var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUserProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_12718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 0.802734C7.68875 0.802734 0.96875 7.52273 0.96875 15.8027C0.96875 24.0827 7.68875 30.8027 15.9688 30.8027C24.2488 30.8027 30.9688 24.0827 30.9688 15.8027C30.9688 7.52273 24.2488 0.802734 15.9688 0.802734ZM15.9688 5.30273C18.4587 5.30273 20.4688 7.31273 20.4688 9.80273C20.4688 12.2927 18.4587 14.3027 15.9688 14.3027C13.4788 14.3027 11.4688 12.2927 11.4688 9.80273C11.4688 7.31273 13.4788 5.30273 15.9688 5.30273ZM15.9688 26.6027C12.2188 26.6027 8.90375 24.6827 6.96875 21.7727C7.01375 18.7877 12.9688 17.1527 15.9688 17.1527C18.9538 17.1527 24.9237 18.7877 24.9688 21.7727C23.0338 24.6827 19.7188 26.6027 15.9688 26.6027Z",
    fill: "#9D98D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_12718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.96875 0.802734)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfile);
export default __webpack_public_path__ + "static/media/icon-user-profile.564d19fcd1b3a43124b78e258c64f5a0.svg";
export { ForwardRef as ReactComponent };